module.exports = __webpack_public_path__ + "01dc2e3e4118e18b0ac08c03c67da614.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/short-s.png
// module id = 2437
// module chunks = 0